import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PreviewDetails.css";

export const PreviewDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pdfName = location.state?.pdfName;
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Parse JSON strings safely
  const parseJSONField = (field) => {
    if (!field) return [];
    try {
      const parsed = JSON.parse(field);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("JSON parse error:", e);
      return [];
    }
  };

  useEffect(()=>{
      const login = sessionStorage.getItem("workerToken");
      if(!login || undefined){
        alert("Login First");
        navigate("/");
      }
    });

  useEffect(() => {
    const fetchPreview = async () => {
      if (!pdfName) {
        setError("No PDF name provided");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/Preview`,
          {
            params: {
              pdfName: pdfName,
            },
            
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("workerToken")}`
            }
          },
        );
        console.log(response.data.data[0]);
        setFormData(response.data.data[0]);
        setError(null);
      } catch (error) {
        console.error("Error fetching preview:", error);
        setError("Failed to load candidate data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchPreview();
  }, [pdfName]);

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="preview-loading">
        <div className="loading-spinner"></div>
        <p>Loading application data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="preview-error">
        <p>{error}</p>
      </div>
    );
  }

  if (!formData) {
    return (
      <div className="preview-error">
        <p>No data available</p>
      </div>
    );
  }

  // Parse education and work experience
  const educationList = parseJSONField(formData.edu_rows);
  const workList = parseJSONField(formData.work_rows);
  console.log("work data ->", workList);

  console.log(workList);

  // Helper to format date
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  // Image URLs
  const photoUrl = formData.photo_path
    ? `${process.env.REACT_APP_FILE_URL}/${formData.photo_path}`
    : null;
  const signatureUrl = formData.signature_path
    ? `${process.env.REACT_APP_FILE_URL}/${formData.signature_path}`
    : null;

  return (
    <div className="preview-container">
      <div className="form-preview">
        {/* Back Button */}
        <div className="back-button-container">
          <button className="back-btn" onClick={handleBack}>
            ← Back
          </button>
        </div>

        {/* Header with Title */}
        <div className="form-header">
          <h1 className="form-title">Candidate Application Preview</h1>
          <div className="form-id">Application ID: {pdfName || "N/A"}</div>
        </div>

        {/* Top Row: Left Details + Right Photos */}
        <div className="top-row">
          <div className="basic-info-summary">
            <div className="info-group">
              <label>Name (English):</label>
              <span>{formData.name_english || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Name (Hindi):</label>
              <span>{formData.name_hindi || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Father's Name:</label>
              <span>{formData.father_name || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Date of Birth:</label>
              <span>{formatDate(formData.dob)}</span>
            </div>
            <div className="info-group">
              <label>Gender:</label>
              <span>{formData.gender || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Category:</label>
              <span>{formData.category || "N/A"}</span>
            </div>
          </div>

          <div className="photo-signature-area">
            <div className="photo-box">
              <div className="photo-label">Passport Size Photo</div>
              {photoUrl ? (
                <img
                  src={photoUrl}
                  alt="Candidate"
                  className="candidate-photo"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                className="photo-placeholder"
                style={{ display: photoUrl ? "none" : "flex" }}
              >
                No Photo
              </div>
            </div>
            <div className="signature-box">
              <div className="signature-label">Signature</div>
              {signatureUrl ? (
                <img
                  src={signatureUrl}
                  alt="Signature"
                  className="candidate-signature"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                className="signature-placeholder"
                style={{ display: signatureUrl ? "none" : "flex" }}
              >
                No Signature
              </div>
            </div>
          </div>
        </div>

        {/* Section: Basic Information (Detailed) */}
        <div className="form-section">
          <h2 className="section-title">Basic Information</h2>
          <div className="section-content two-columns">

            <div className="info-group">
              <label>Religion:</label>
              <span>{formData.religion || "N/A"}</span>
            </div>

            <div className="info-group">
              <label>Caste:</label>
              <span>{formData.caste || "N/A"}</span>
            </div>

            <div className="info-group">
              <label>Post Applied For:</label>
              <span>{formData.post || "N/A"}</span>
            </div>

            {/* ✅ NEW FIELD */}
            <div className="info-group">
              <label>विभाग:</label>
              <span>{formData.vibhag || "N/A"}</span>
            </div>

          </div>
        </div>

        {/* Section: Contact Details */}
        <div className="form-section">
          <h2 className="section-title">Contact Details</h2>
          <div className="section-content two-columns">
            <div className="info-group">
              <label>Mobile Number:</label>
              <span>{formData.mobile || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Email Address:</label>
              <span>{formData.email || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Aadhar Number:</label>
              <span>{formData.aadhar_number || "N/A"}</span>
            </div>

            {/* Address - Full Width */}
            <div className="info-group full-width">
              <label>Complete Address:</label>
              <span className="address-text">{formData.address || "N/A"}</span>
            </div>

            <div className="info-group">
              <label>PIN Code:</label>
              <span>{formData.pin_code || "N/A"}</span>
            </div>
          </div>
        </div>

        {/* Section: Education */}
        <div className="form-section">
          <h2 className="section-title">Educational Qualifications</h2>

          <div className="section-content">
            {educationList.length > 0 ? (
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Examination</th>
                      <th>Marks</th>
                      <th>Percentage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {educationList.map((edu, index) => (
                      <tr key={index}>
                        <td>{edu.l || "N/A"}</td>
                        <td>
                          {edu.obtain && edu.total
                            ? `${edu.obtain}/${edu.total}`
                            : "N/A"}
                        </td>
                        <td>{edu.percentage ? `${edu.percentage}` : "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="no-data">No education details available</p>
            )}
          </div>
        </div>

        {/* Section: Work Experience */}
        <div className="form-section">
          <h2 className="section-title">Work Experience</h2>
          <div className="section-content">
            {workList && workList.length > 0 ? (
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Organization</th>
                      <th>Post / Designation</th>
                      <th>Duration</th>
                      <th>Salary</th>
                    </tr>
                  </thead>
                  <tbody>
                    {workList.map((work, index) => (
                      <tr key={index}>
                        <td>{work.o || work.organization || "N/A"}</td>
                        <td>{work.p || work.designation || "N/A"}</td>
                        <td>{work.d || work.experience || "N/A"}</td>
                        <td>{work.s || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="no-data">No work experience details available</p>
            )}
          </div>
        </div>

        {/* Section: Typing Skills */}
        <div className="form-section">
          <h2 className="section-title">Typing Skills</h2>
          <div className="section-content three-columns">
            <div className="info-group">
              <label>Hindi Typing (WPM):</label>
              <span>{formData.hindi_typing || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>English Typing (WPM):</label>
              <span>{formData.english_typing || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Shorthand Speed:</label>
              <span>{formData.shorthand_speed || "N/A"}</span>
            </div>
          </div>
        </div>

        {/* Section: Payment Details */}
        <div className="form-section">
          <h2 className="section-title">Payment Details</h2>
          <div className="section-content two-columns">
            <div className="info-group">
              <label>Payment Method:</label>
              <span>{formData.payment_method || "N/A"}</span>
            </div>
            <div className="info-group">
              <label>Transaction/Reference Number:</label>
              <span>{formData.payment_number || "N/A"}</span>
            </div>
          </div>
        </div>

        {/* Footer with verification note */}
        <div className="form-footer">
          <p>
            I hereby declare that all the information provided above is true and
            correct to the best of my knowledge.
          </p>
        </div>
      </div>
    </div>
  );
};